import * as React from 'react'
import cx from 'classnames'
import Spinner from 'components/Spinner'
import styles from './LoadingOverlay.sass'

/**
 * The LoadingOverlay
 */
export default function LoadingOverlay({
  'data-test': dataTest,
}: {
  ['data-test']?: string
}) {
  return (
    <div className={cx(styles.root)} data-test={dataTest}>
      <Spinner size={24} />
    </div>
  )
}
